import React, { PureComponent } from 'react'
import Loader from 'react-loading'
import './index.css'

class Loading extends PureComponent {
  render() {
    return (
      <div className={ 'loading' }>
        <Loader type="spin" color="#000" />
      </div>
    )
  }
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js